import React, { useRef } from "react";
import { Button } from "@mui/material";
import { CSVLink } from "react-csv";

const CustomButton = React.forwardRef(({ text, fontSize, height = "auto", width = "auto", color, onClick, icon: IconComponent, csvData, ...props }, ref) => {

  return (
    <Button
      {...props}
      sx={{
        background: color ? color : "#fff",
        borderRadius: "7.91px",
        color: "#000",
        fontFamily: 'Inter, sans-serif',
        minWidth:"0px",
        fontSize: fontSize ? fontSize : "16px",
        textTransform: "none",
        height: height,
        width: width,
        display: "flex",
        border: "1px solid #d0d5dd",
        alignItems: "center",
        gap: "5px", // Space between icon and text
        "&:hover": {
          background: color ? color : "#fff",
        },
      }}
      onClick={onClick}
      ref={ref}
    >
      {IconComponent && <IconComponent sx={{ fontSize: "18px", color: "#000" }} />} {/* Render dynamic icon */}
      {text}
    </Button>
  );
});

export default CustomButton;
